<template>
  <page
    v-if="hasLoad"
    :custom-style="{
      display: 'flex',
      position: 'relative',
      flexDirection: 'column',
      height: '100vh',
      'padding-top': pagePaddingTop
    }"
  >
    <div class="mask"></div>
    <!-- 导航 -->
    <maple-nav-bar
      v-if="!browerInfo.isMiniProgram"
      class="nav-bar"
      title="会员权益"
      opacity-style
      left-arrow
      :safe-top-distance="statusBarHeight"
      :opacity="opacity"
      :background="navBg"
      @click-left="goBack"
    >
      <template v-if="!browerInfo.isMiniProgram" #right>
        <div class="nav-right" @click="showMore">
          <img src="@/images/member/more.png" class="more" />
          <!-- 购买记录蒙层 -->
          <div v-if="showMoreInfo" class="more-list" @click.stop="showMore">
            <div class="content" :style="{ top: moreTop }">
              <div class="buy" @click.stop="goBuyList">
                <img src="@/images/member/buy-icon.png" class="icon" />
                购买记录
              </div>
              <div class="rule" @click.stop="goRule">
                <img src="@/images/member/rule-icon.png" class="icon" />
                会员规则
              </div>
            </div>
          </div>
        </div>
      </template>
    </maple-nav-bar>
    <template v-if="hasMemberActiviy">
      <div
        ref="memberContent"
        :class="[
          'member-content',
          browerInfo.isMiniProgram ? 'mini' : '',
          !openMember ? 'no-open' : ''
        ]"
        :style="{
          // 'padding-bottom': pagePaddingBottom
        }"
      >
        <!-- 小程序购买记录 -->
        <div v-if="browerInfo.isMiniProgram" class="mini-buy">
          <div class="buy" @click.stop="goBuyList">
            <img src="@/images/member/buy-icon.png" class="icon" />
            购买记录
          </div>
          <div class="rule" @click.stop="goRule">
            <img src="@/images/member/rule-icon.png" class="icon" />
            会员规则
          </div>
        </div>

        <div
          v-if="!openMember && memberInfoList.length > 0 && !notShowTitle"
          class="member-title-wrapper"
        >
          <div
            v-for="(info, index) in memberInfoList"
            :key="index"
            :class="['member-title', activeIndex === index ? 'active' : '']"
            @click="changeMember(info, index)"
          >
            <span class="text">
              {{ info.name }}
              <span v-if="info.tips" class="experience-tip">{{
                info.tips
              }}</span>
            </span>
          </div>
        </div>

        <!-- 会员卡说明 -->
        <div class="member-desc-wrapper">
          <div :class="['member-desc', openMember ? 'open' : '']">
            <div class="info">
              <div class="logo-wrapper">
                <img
                  :src="currenCardInfo.cardImg"
                  :class="['logo', appKey === 'small' ? 'member' : '']"
                />
                <div v-if="openMember && !isMemberMall" class="member-type">
                  {{ memberName }}
                </div>
              </div>

              <div v-if="endDate" class="date">{{ endDate }}</div>
            </div>
            <div
              v-if="
                currenCardInfo.conserveTips && currenCardInfo.conserveTips.money
              "
              class="desc"
            >
              {{
                openMember ? '会员预计为您节省' : `${btnText}会员预计最多可省`
              }}
              <span class="money">{{ conserveTips.money }}</span
              >{{ conserveTips.effectiveUnit }}
            </div>
          </div>
          <div v-if="upgradeRule" class="rule-tip">{{ upgradeRule }}</div>
        </div>

        <!-- 会员权益 -->
        <div v-if="openMember" class="member-title-wrapper">
          <div class="member-title active">
            <span class="text">我的会员权益</span>
          </div>
        </div>

        <div v-if="!openMember && benefitsLength > 0" class="member-tip">
          {{ btnText }}会员享{{ benefitsLength }}大权益
        </div>
        <div v-if="hasCouponList" class="coupon-right-wrapper">
          <div class="member-right-num">权益1</div>
          <div class="title">{{ couponInfo.title }}</div>
          <div class="coupon-list">
            <div class="coupon-scroll">
              <couponItem
                v-for="conpon in couponInfo.couponList"
                :key="conpon.couponId"
                :coupon="conpon"
                :open-member="openMember"
              />
            </div>
          </div>
        </div>
        <div class="member-rights">
          <div v-for="(item, index) in memberRights" :key="index" class="right">
            <div class="member-right-num">
              权益{{ hasCouponList ? index + 2 : index + 1 }}
            </div>
            <div class="name">{{ item.title }}</div>
            <div class="desc">{{ item.subTitle }}</div>
            <div class="tip">{{ item.desc }}</div>
          </div>
        </div>
      </div>
      <div
        v-if="openMember"
        class="open-member-bottom"
        :style="{
          // bottom: `${10 + safeBottomMargin}px`
        }"
        @click="goAgreement"
      >
        《{{ APP_CONFIG.app_short_name }}会员协议》
      </div>
      <div
        v-if="!openMember"
        class="member-bottom"
        :style="{
          //  bottom: `${safeBottomMargin}px`
        }"
      >
        <div class="rule-wrapper">
          <div @click="changeSelectRule">
            <IconFont
              :name="
                isSelectRule ? 'xuankuang-gouxuan' : 'xuankuang-weixuanzhong'
              "
              :color="isSelectRule ? '#15BB5C' : '#D9D9D9'"
              size="11px"
            />
            <span class="text-label">我已阅读并同意</span>
          </div>

          <span class="rule" :class="themeColorClass" @click="goAgreement"
            >《{{ APP_CONFIG.app_short_name }}会员协议》</span
          >
        </div>
        <div class="open-btn-wrapper">
          <div class="left">
            <span class="unit">￥</span
            ><span class="price">{{ currenCardInfo.realPrice }}</span
            ><span class="unit">{{ currenCardInfo.effectiveDays }}</span
            ><span v-if="currenCardInfo.originalPrice" class="origin"
              >￥{{ currenCardInfo.originalPrice }}</span
            >
          </div>
          <div
            class="open-btn"
            :style="{ backgroundImage: `url(${memberOpenBg})` }"
            @click="goOpenMember"
          >
            立即{{ btnText }}
          </div>
        </div>
      </div>
      <div v-if="showMask" class="mask-wrapper" @click="closeMask">
        <div class="rule-mask"></div>
        <div class="content">
          <div class="rule-tip">
            我已阅读并同意<span
              class="rule"
              :class="themeColorClass"
              @click="goAgreement"
              >《{{ APP_CONFIG.app_short_name }}会员协议》</span
            >
          </div>
          <div class="btn-wrapper">
            <div class="cancel" @click="cancelClick">不同意</div>
            <div
              class="confirm"
              :class="themeColorClass"
              @click="agreePayClick"
            >
              同意并支付
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <empty :desc="emptyDesc" :type="1" class="empty-box"></empty>
    </template>
  </page>
</template>
<script>
import couponItem from './components/couponItem.vue'
import { API } from '@/api'
import Url from '@mc/mc-utils/js/url/url'
import { nativeRedirect } from '@/utils/native_interactions/native_redirect'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
import Empty from '@/common/layout/empty/index'
import { NavBar } from '@mc/mc-jsbridge'
import { userInfo } from '@/utils/user'
import { APP_CONFIG, memberOpenBg } from '@/defines/environment/config'
import { appKey } from '@/defines/environment'
import themeMixin from '@/common/mixins/theme'
import memberLogo from '@/images/member/member-logo.png'
import memberSaveLogo from '@/images/member/member_save_logo.png'
export default {
  name: 'McMemberIndex',
  components: {
    couponItem,
    Empty
  },
  mixins: [themeMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const navBar = new NavBar(0)

      navBar.init()
      document.title = '会员权益'
      vm.getBenefits()
      vm.handleScroll()
    })
  },

  data() {
    return {
      browerInfo: window.matrix,
      showMoreInfo: false,
      opacity: 1,
      openMember: false,
      memberInfoList: [],
      activeIndex: 0,
      memberRights: [],
      isSelectRule: false,
      showMask: false,
      navOpacity: true,
      endDate: '',
      memberName: '',
      couponInfo: {
        couponList: []
      },
      currenCardInfo: {},
      hasMemberActiviy: false,
      hasLoad: false,
      benefitsLength: 0,
      emptyDesc: '系统异常，请稍后再试',
      upgradeRule: '',
      action: 0,
      notShowTitle: false,
      APP_CONFIG,
      memberOpenBg,
      appKey
    }
  },
  computed: {
    pagePaddingTop() {
      if (!this.browerInfo.isMiniProgram) {
        return 44 + this.statusBarHeight + 'px'
      } else {
        return '0px'
      }
    },
    pagePaddingBottom() {
      if (!this.openMember) {
        return 73 + this.safeBottomMargin + 'px'
      } else {
        return 0
      }
    },
    moreTop() {
      if (!this.browerInfo.isMiniProgram) {
        return 40 + this.statusBarHeight + 'px'
      } else {
        return '0px'
      }
    },
    navBg() {
      return this.navOpacity
        ? 'transparent'
        : `rgba(255, 255, 255, ${this.opacity})`
    },
    conserveTips() {
      return this.currenCardInfo.conserveTips
    },
    hasCouponList() {
      return (
        this.couponInfo &&
        this.couponInfo.couponList &&
        this.couponInfo.couponList.length &&
        this.couponInfo.couponList.length > 0
      )
    },
    btnText() {
      // //1开通，2升级
      // eslint-disable-next-line eqeqeq
      return this.action == 2 ? '升级' : '开通'
    },
    isMemberMall() {
      return userInfo.isMemberMall
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', this.pageShow)
  },
  methods: {
    pageShow() {
      if (!document.hidden) {
        this.getBenefits()
        this.handleScroll()
      }
    },
    async getBenefits() {
      try {
        const url = new Url(window.location.href)
        const query = url.parseQuerystring()
        const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
        const cardId = query.card_id || hashQuery.card_id || ''
        const action = query.action || hashQuery.action
        this.action = action
        const parmas = {
          cardId
        }
        if (action) {
          parmas.action = action
        }
        const resData = await API.primeCard.primeCardBenefits(parmas)

        this.emptyDesc = '抱歉，会员活动已结束'

        this.openMember = resData?.payStatus === 1
        this.endDate = resData?.endDate || ''
        this.primeCardAgreement = resData?.primeCardAgreement || ''
        this.primeCardRuleLink = resData?.primeCardRuleLink || ''
        this.cardList = resData?.cardList || []
        this.upgradeRule = resData?.upgradeRule || ''

        this.hasMemberActiviy = resData?.cardList.length > 0
        const activeIndex = this.cardList.findIndex(
          item => item.isDefault && Number(item.isDefault) === 1
        )
        this.activeIndex = activeIndex
        this.memberName = this.openMember
          ? this.cardList[activeIndex]?.name
          : ''
        this.memberInfoList = this.cardList.map(item => {
          return {
            name: item.name,
            tips: item.tips
          }
        })
        const { memberRights, couponList, currenCardInfo } = this.getCurrenCard(
          activeIndex
        )
        this.memberRights = memberRights
        this.couponInfo = couponList[0] || {}
        this.currenCardInfo = currenCardInfo
        this.hasLoad = true
        this.notShowTitle =
          userInfo.isMemberMall && this.memberInfoList.length === 1
      } catch (e) {
        this.hasMemberActiviy = false
        this.hasLoad = true
        if (e.res && e.res.error) {
          const { msg } = e.res.error
          this.$toast(msg)
        }
      }
    },
    getCurrenCard(index) {
      const currenCard = this.cardList[index]
      const benefits = currenCard?.benefits || []
      this.benefitsLength = benefits.length
      const memberRights = benefits.filter(item => item.type !== 2) || []
      const couponList = benefits.filter(item => item.type === 2) || []
      const currenCardInfo = {
        originalPrice: currenCard?.originalPrice,
        realPrice: currenCard?.realPrice,
        effectiveDays: currenCard?.effectiveDays,
        cardId: currenCard?.cardId,
        conserveTips: currenCard?.conserveTips || {},
        benefits: currenCard?.benefits || [],
        cardImg: appKey === 'small' ? memberSaveLogo : memberLogo
      }
      return {
        memberRights,
        couponList,
        currenCardInfo
      }
    },
    handleScroll() {
      window.addEventListener('scroll', e => {
        const boundingTop = this.$refs.memberContent.getBoundingClientRect().top
        const pageTop = 44 + this.statusBarHeight
        if (boundingTop <= 0) {
          this.opacity = 1
          this.navOpacity = false
        }
        if (boundingTop > 0 && boundingTop < pageTop) {
          this.opacity = Math.abs(boundingTop) / pageTop
        }
        if (boundingTop >= pageTop) {
          this.opacity = 1
          this.navOpacity = true
        }
      })
    },
    goBack() {
      this.$back()
    },
    showMore() {
      this.showMoreInfo = !this.showMoreInfo
    },
    goBuyList() {
      this.$track(this.$trackMap.memberIndex.buyHistoryClick)
      this.$router.push({
        name: 'memberBuyList'
      })
    },
    changeMember(info, index) {
      this.activeIndex = index
      const { memberRights, couponList, currenCardInfo } = this.getCurrenCard(
        index
      )

      this.memberRights = memberRights
      this.couponList = couponList
      this.couponInfo = couponList[0]
      this.currenCardInfo = currenCardInfo
      this.$track(this.$trackMap.memberIndex.typeClick, {
        paid_member_type: String(currenCardInfo.cardType || ''),
        pay_member_benefit: this.getTracerBenefit()
      })
    },
    goAgreement() {
      this.$track(this.$trackMap.memberIndex.AgreementClick)
      if (this.primeCardAgreement) {
        this.$autoRedirect(this.primeCardAgreement)
      }
    },
    getTracerBenefit() {
      const benefits = this.currenCardInfo?.benefits || []
      const typeList = []
      benefits.forEach(item => {
        typeList.push(item.type)
      })
      const typeStr = typeList.join(',')
      return typeStr
    },
    goRule() {
      this.$track(this.$trackMap.memberIndex.ruleClick)
      if (this.primeCardRuleLink) {
        this.$autoRedirect(this.primeCardRuleLink)
      }
    },
    changeSelectRule() {
      this.isSelectRule = !this.isSelectRule
    },
    goOpenMember() {
      this.$track(this.$trackMap.memberIndex.openClick, {
        paid_member_type: String(this.currenCardInfo.cardType || ''),
        pay_member_benefit: this.getTracerBenefit(),
        member_price: String(this.currenCardInfo.realPrice || ''),
        line_price_member: String(this.currenCardInfo.originalPrice || ''),
        member_time: String(this.currenCardInfo.effectiveDays || '')
      })
      if (!this.isSelectRule) {
        this.showMask = true
      } else {
        this.agreePay()
      }
    },
    closeMask() {
      this.showMask = false
    },
    cancelClick() {
      this.$track(this.$trackMap.memberIndex.cancleClick)
      this.closeMask()
    },
    agreePayClick() {
      this.$track(this.$trackMap.memberIndex.agreeClick)
      this.agreePay()
    },
    async agreePay() {
      const cardId = this.currenCardInfo.cardId
      try {
        const res = await API.primeCard.primeCardPrePay({ cardId })
        nativeRedirect(nativeRoutes.cashier, {
          paySecret: res.paySecret,
          agentId: res.agentId,
          useType: 1,
          source: 'vip'
        })
      } catch (e) {
        if (e.res && e.res.error) {
          const { msg } = e.res.error
          this.$toast(msg || '支付失败')
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
.mask {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 4.92rem;

  background-image: linear-gradient(180deg, #fff0df, #ffffff);
}
.more-list {
  position: fixed;
  top: 0;
  left: 0;
  z-index: $z-mask;

  width: 100%;
  height: 100%;

  background-color: transparent;

  .content {
    position: absolute;
    top: 0.8rem;
    right: 0.24rem;

    padding: 0.24rem;

    background-color: #fff;
    border-radius: 0.16rem;
    &:after {
      display: block;

      position: absolute;
      top: -2.5px;
      right: -4px;
      transform: translateX(-10px);

      border-width: 0 5px 5px 5px;
      border-style: solid;
      border-color: transparent transparent #fff transparent;

      content: '';
    }
    .buy {
      margin-bottom: 0.44rem;
    }
    .buy,
    .rule {
      @include flex-row-center;
      @include text(0.28rem, #595959);
      .icon {
        width: 0.32rem;
        height: 0.32rem;
        margin-right: 0.12rem;
      }
    }
  }
}
.nav-bar {
  position: fixed;
  top: 0;
  z-index: $z-navigation-bar;

  width: 100vw;
  .nav-right {
    .more {
      width: 0.48rem;
      height: 0.48rem;
    }
  }
}
.member-content {
  position: relative;

  padding: 6px 0;

  @include iphonex-padding-bottom(0px);

  &.mini {
    padding-top: 0px;
  }
  &.no-open {
    @include iphonex-padding-bottom(90px);
  }
  .mini-buy {
    display: flex;

    margin: 0 12px;
    padding: 0.16rem 0;

    justify-content: flex-end;

    align-items: center;
    .buy,
    .rule {
      @include flex-row-center;
      @include text(0.28rem, #595959);
      .icon {
        width: 0.32rem;
        height: 0.32rem;
        margin-right: 0.08rem;
      }
    }
    .buy {
      margin-right: 0.26rem;
    }
  }
  .member-desc-wrapper {
    margin: 12px 12px 24px 12px;
    .rule-tip {
      margin-top: 0.24rem;
      @include text(0.24rem, #8c8c88);
    }
  }

  .member-desc {
    padding: 0.44rem 0.24rem 0.44rem 0.24rem;

    background-image: linear-gradient(to right, #333a4d, #20283d);

    border-radius: 0.24rem;

    .info {
      @include flex-row-between;
      .logo-wrapper {
        @include flex-row-center;
        .logo {
          width: 1.9rem;
          height: 0.4rem;
          &.member {
            width: 1.76rem;
          }
        }
        .member-type {
          margin-left: 0.16rem;
          padding: 0.04rem 0.08rem;

          background-image: linear-gradient(to right, #ffe5c7, #ffd2a6);

          border-radius: 0.08rem;

          @include text(0.22rem, #373d50);
        }
      }

      .date {
        @include text(0.26rem, #e8c8a8);
      }
    }
    .desc {
      margin-top: 0.16rem;
      @include text(0.26rem, #ffe9d3);
      .money {
        font-size: 0.48rem;
        font-weight: bold;
      }
    }
  }

  .member-title-wrapper {
    height: 0.88rem;
    @include flex-row-center;
    .member-title {
      position: relative;

      height: 0.88rem;

      flex: 1;

      @include text(0.32rem, #252d42);
      @include flex-row-center;
      .text {
        position: relative;
      }
      .experience-tip {
        position: absolute;
        top: -0.32rem;
        left: 0;

        max-width: 1.8rem;
        height: 0.32rem;
        padding: 0.04rem 0.08rem;
        box-sizing: border-box;

        background-image: linear-gradient(to right, #ff6200, #ff1000);

        border-radius: 0.16rem 0.16rem 0.16rem 0.02rem;

        white-space: nowrap;
        @include text(0.24rem, #fff);
        @include text-overflow-ellipsis-single;
      }

      &.active {
        .text {
          background-image: url('../../images/member/title_bg.png');
          background-repeat: no-repeat;
          background-position: bottom;
          background-size: 100% 0.12rem;

          font-size: 0.4rem;
          font-weight: bold;
        }
      }
    }
  }
  .member-tip {
    margin: 0 12px 0.16rem 12px;

    font-weight: bold;

    @include text(0.32rem, #232d44);
  }
  .coupon-right-wrapper {
    position: relative;

    height: 3rem;
    margin: 0 12px 0.16rem 12px;
    padding: 0.2rem 0 0.32rem 0.24rem;
    box-sizing: border-box;

    background-image: linear-gradient(to bottom, #fffbf5, #fef7e9);
    border-radius: 0.24rem;
    border: 1px solid rgba(255, 241, 216, 1);
    .title {
      margin-bottom: 0.28rem;

      @include text(0.32rem, #232d44, true);
      @include flex-row-center;
    }
    .coupon-list {
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;

      .coupon-scroll {
        width: max-content;

        @include flex(row, flex-start, center, nowrap);

        &::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }
  .member-rights {
    margin: 0 0.24rem;

    @include flex(row, space-between, center, wrap);
    .right {
      position: relative;

      width: 3.4rem /* 150/50 */;
      height: 1.74rem;
      margin-top: 0.16rem;
      padding: 0.5rem 0.22rem 0.04rem 0.24rem;
      box-sizing: border-box;

      background-image: linear-gradient(to bottom, #fffbf5, #fef7e9);
      border-radius: 0.24rem;
      border: 1px solid rgba(255, 241, 216, 1);
      // &:nth-child(2n + 1) {
      //   margin-right: 0.2rem;
      // }
      &:nth-child(1) {
        margin-top: 0;
      }
      &:nth-child(2) {
        margin-top: 0;
      }

      .name {
        height: 0.44rem;

        line-height: 0.44rem;
        font-weight: bold;
        @include text(0.32rem, #232d44);
        @include text-overflow-ellipsis-single;
      }
      .desc,
      .tip {
        height: 0.34rem;
        margin-top: 0.04rem;

        line-height: 0.34rem;
        @include text(0.24rem, #8a542f);
        @include text-overflow-ellipsis-single;
      }
    }
  }

  .member-right-num {
    position: absolute;
    top: 0;
    left: 0;

    padding: 0.04rem 0.12rem;

    background-color: #fee8d0;
    border-radius: 0.16rem 0 0.16rem 0;

    @include text(0.24rem, #793d10, true);
  }
}
.open-member-bottom {
  position: absolute;

  width: 100vw;
  @include flex-row-center;
  @include text(0.24rem, #bfbfbf);
  @include iphonex-fixed-bottom(10px);
}
.member-bottom {
  position: fixed;

  width: 100vw;
  padding: 4px 12px;

  background-color: #fff;

  @include iphonex-fixed-bottom(0px);

  .rule-wrapper {
    padding-top: 4px;

    font-size: 0.24rem;
    @include flex-row-center;

    .text-label {
      margin-left: 0.08rem;

      color: #8c8c8c;
    }
    .rule {
      color: #15bb5c;
    }
  }
  .open-btn-wrapper {
    height: 0.88rem;
    margin-top: 0.16rem;

    background-image: linear-gradient(to right, #333a4d, #20283d);
    border-radius: 0.44rem;

    @include flex-row-center;
    .left {
      padding-left: 0.56rem;

      flex: auto;

      @include flex(row, flex-start, center);
      .unit {
        @include text(0.32rem, #fee8d0);
      }
      .price {
        @include text(0.4rem, #fee8d0);
      }
      .origin {
        text-decoration: line-through;

        @include text(0.32rem, #baa794);
      }
    }
    .open-btn {
      width: 2.42rem;
      height: 0.88rem;

      // background-image: url('../../images/member/open_bg.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;

      border-radius: 0.22rem 0.44rem 0.44rem 0;
      @include flex-row-center;
      @include text(0.32rem, #fff);
    }
  }
}
.mask-wrapper {
  .rule-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: $z-mask;

    width: 100%;
    height: 100%;

    background-color: rgba(0, 0, 0, 0.5);
  }
  .content {
    display: flex;

    position: fixed;
    top: 50%;
    right: 0;
    bottom: 0;
    left: 50%;
    z-index: $z-mask + 1;

    transform: translate(-50%, -50%);

    width: 5.9rem;
    height: 2.66rem;

    background-color: white;
    border-radius: 0.16rem;

    flex-direction: column;

    font-size: 0.32rem;
    font-weight: 500;
    color: #262626;

    .rule-tip {
      border-bottom: 1px solid #f5f5f5;

      flex: auto;

      @include flex-row-center;
      .rule {
        color: #15bb5c;
      }
    }
    .btn-wrapper {
      height: 1.12rem;
      @include flex-row-between;
      .cancel {
        height: 100%;

        border-right: 1px solid #f5f5f5;

        flex: 1;

        font-weight: normal;
        color: #595959;
        @include flex-row-center;
      }
      .confirm {
        height: 100%;

        flex: 1;

        color: #15bb5c;
        @include flex-row-center;
      }
    }
  }
}
</style>
